import { z } from 'zod';

export interface CommerceWithService {
  id: string;
  commerceId: string;
  commercialServiceId: string;
  commercialService: {
    id: string;
    name: string;
    description?: string | null;
    commercialName?: string | null;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface NewCommerceWithService {
  commerceId: string;
  commercialServiceId: string;
}

export interface CommerceWithServiceFilters {
  commerceId?: string;
  search?: string;
}

export const commerceWithServiceSchema = z.object({
  commerceId: z.string().min(1, 'El Comercio es requerido'),
  commercialServiceId: z
    .string()
    .min(1, 'Debe seleccionar un Servicio Comercial'),
});

export type CommerceWithServiceSchema = z.infer<
  typeof commerceWithServiceSchema
>;

export const defaultCommerceWithServiceValues: CommerceWithServiceSchema = {
  commerceId: '',
  commercialServiceId: '',
};
